import useStore from "./_store"
import QCUser from "./_QCUser"
import { useEffect, useImperativeHandle, useMemo, useRef, useState, forwardRef } from "react"


export default forwardRef((_, ref) => {
	const [isLoading, setIsLoading] = useState(false)
	const [userSearch, setUserSearch] = useState('')
	const currentQCUsers = useStore((state) => state.currentQCUsers)

	const filteredQCUsers = useMemo(() => {
		if (currentQCUsers == null) return null
		if (currentQCUsers.length === 0) return currentQCUsers
		const q = userSearch.trim().toLowerCase()
		if (!q) return currentQCUsers
		return currentQCUsers.filter((u) => {
			const haystack = [u.first_name, u.last_name, u.user_name, u.email]
				.filter(Boolean)
				.join(' ')
				.toLowerCase()
			return haystack.includes(q)
		})
	}, [currentQCUsers, userSearch])

	if (!ref) ref = useRef(null)

	useImperativeHandle(ref, () => {
		return {
			setIsLoading,
		}
	})

	useEffect(() => {
		if (currentQCUsers == null) setUserSearch('')
	}, [currentQCUsers])

	const loader =
		<div className="grow flex flex-col items-center">
			<div className="lds-ring m-1.5">
				<div></div> 
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>

 

	let content
	if (currentQCUsers == null) {
		content = <p>No qc users found</p>
	} else if (filteredQCUsers.length === 0 && userSearch.trim()) {
		content = <p>No users match your search</p>
	} else {
		content = filteredQCUsers.map((qcUser) => (
			<QCUser key={qcUser.id} user={qcUser} />
		))
	}

	const renderedContent = isLoading ? loader : content

	return <>
		<div className="border-grey rounded-primary p-2 border-normal">
			{currentQCUsers?.length > 0 && (
				<input
					type="text"
					className="input-field w-full mb-2"
					placeholder="Search users…"
					value={userSearch}
					onChange={(e) => setUserSearch(e.target.value)}
					aria-label="Search users"
				/>
			)}
			<div className="flex flex-col max-h-[400px] overflow-y-auto min-w-[800px] divide-y divide-grey divide-opacity-50">
				{renderedContent}
			</div>
		</div>
	</>
})